import { Box, Modal, Typography } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import Button from "@accredo/fe-shared/theme/components/Button.jsx";
import PropTypes from "prop-types";

const ConfirmNonExactMatchDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6">Keine exakte Übereinstimmung</Typography>
        </Box>

        <Typography variant="body2" sx={{ mb: 3 }}>
          Für die ausgewählte Zahlung wurde keine exakte Übereinstimmung zu
          diesem Schaden gefunden. Möchten Sie die Zahlung trotzdem diesem
          Schaden zuordnen?
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Button onClick={onConfirm} variant="primary" fullWidth>
            Ja, Zahlung zuordnen
          </Button>
          <Button onClick={onClose} variant="tertiary" fullWidth>
            Abbrechen
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

ConfirmNonExactMatchDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmNonExactMatchDialog;
